interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function OctagonCheckIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M10.3406 0.003125C10.7375 0.003125 11.1187 0.1625 11.4 0.44375L15.5719 4.6125C15.8531 4.89375 16.0125 5.275 16.0125 5.67188V10.3219C16.0125 10.7188 15.8531 11.1 15.5719 11.3813L11.4 15.5594C11.1187 15.8406 10.7375 16 10.3406 16H5.69063C5.29375 16 4.9125 15.8406 4.63125 15.5594L0.45625 11.3875C0.175 11.1062 0.015625 10.725 0.015625 10.3281V5.67812C0.015625 5.28125 0.175 4.9 0.45625 4.61875L4.62813 0.440625C4.90938 0.159375 5.29063 0 5.6875 0H10.3375L10.3406 0.003125ZM1.51562 5.675V10.325L5.6875 14.4969H10.3375L14.5094 10.325V5.675L10.3375 1.50312H5.6875L1.51562 5.675ZM10.65 6.64687L8.15 10.6469C8.01875 10.8563 7.79375 10.9875 7.54688 11C7.3 11.0125 7.0625 10.9 6.91563 10.7L5.41563 8.7C5.16563 8.36875 5.23438 7.9 5.56563 7.65C5.89688 7.4 6.36562 7.46875 6.61562 7.8L7.45937 8.925L9.37813 5.85313C9.59688 5.50313 10.0594 5.39375 10.4125 5.61562C10.7656 5.8375 10.8719 6.29688 10.65 6.65V6.64687Z" />
    </svg>
  );
}
